// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".large_title[data-v-ef07c69c]{margin:40px auto 6px;color:#282729;font-size:28px;line-height:40px;font-weight:600;text-align:center}.sub_title[data-v-ef07c69c]{margin-bottom:20px;color:#999;font-size:16px;line-height:22px;text-align:center}.sure_btn[data-v-ef07c69c]{margin-top:30px!important}.has_account[data-v-ef07c69c]{margin-top:20px;font-size:14px;line-height:20px;text-align:center}.has_account .high_light[data-v-ef07c69c]{cursor:pointer;color:#ff3973;margin:0 4px}", ""]);
// Exports
module.exports = exports;
